"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@mui/material/styles");

var _classnameGenerator = require("./classname-generator");

var _global = _interopRequireDefault(require("global"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Return theme if it has been registered, otherwise create a new
 * theme and save it to theme registry
 *
 * @param {Object} props
 * @param {function} [props.getThemeObject] - Theme object getter
 * @param {string} [props.prefix] - Theme prefix
 * @param {...*} [additionalThemeOptions] - Additional arguments to deep merge with MUI theme
 */
var getThemeProviderProps = function getThemeProviderProps(_ref) {
  var getThemeObject = _ref.getThemeObject,
      prefix = _ref.prefix,
      additionalThemeOptions = _ref.additionalThemeOptions;
  var registeredTheme = _global.default.adsk.dhig2021.themeRegistry[prefix]; // Verify if a theme has been created for the current theme provider instance

  if (!registeredTheme) {
    var themeObject = getThemeObject();
    var theme = (0, _styles.createTheme)(themeObject, additionalThemeOptions);
    _global.default.adsk.dhig2021.themeRegistry[prefix] = {
      theme: theme
    };
  } else {
    console.info("Digital HIG: A theme with prefix \"".concat(prefix, "\" already exists"));
  }

  return _global.default.adsk.dhig2021.themeRegistry[prefix];
};
/**
 * MUI theme wrapper
 *
 * @param {Object} props
 * @param {JSX.Element} props.children
 * @param {Function} props.getThemeObject
 * @param {string} [props.prefix] - Optional prefix to add to generated classnames
 * @param {...*} [additionalThemeOptions] - Additional options to deep merge with MUI theme
 */


var ThemeMuiBase = function ThemeMuiBase(_ref2) {
  var _window$adsk, _window$adsk$dhig;

  var children = _ref2.children,
      getThemeObject = _ref2.getThemeObject,
      _ref2$prefix = _ref2.prefix,
      prefix = _ref2$prefix === void 0 ? "" : _ref2$prefix,
      additionalThemeOptions = _objectWithoutProperties(_ref2, ["children", "getThemeObject", "prefix"]);

  // Initialize an array to record existing themes on current document
  if (!((_window$adsk = _global.default.adsk) !== null && _window$adsk !== void 0 && (_window$adsk$dhig = _window$adsk.dhig2021) !== null && _window$adsk$dhig !== void 0 && _window$adsk$dhig.themeRegistry)) {
    _global.default.adsk = _global.default.adsk || {};
    _global.default.adsk.dhig2021 = _global.default.adsk.dhig2021 || {};
    _global.default.adsk.dhig2021.themeRegistry = {};
  }

  (0, _classnameGenerator.configureClassnameGenerator)({
    prefix: prefix
  });

  var _getThemeProviderProp = getThemeProviderProps({
    getThemeObject: getThemeObject,
    prefix: prefix,
    additionalThemeOptions: additionalThemeOptions
  }),
      theme = _getThemeProviderProp.theme;

  return /*#__PURE__*/_react.default.createElement(_styles.StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, children));
};

ThemeMuiBase.propTypes = {
  /**
   * The content to wrap in the ThemeProvider
   */
  children: _propTypes.default.any.isRequired,

  /**
   * Function that provides the theme object
   */
  getThemeObject: _propTypes.default.func.isRequired,

  /**
   * An arbitrary theme prefix
   */
  prefix: _propTypes.default.string
};
ThemeMuiBase.__docgenInfo = {
  "description": "MUI theme wrapper\n\n@param {Object} props\n@param {JSX.Element} props.children\n@param {Function} props.getThemeObject\n@param {string} [props.prefix] - Optional prefix to add to generated classnames\n@param {...*} [additionalThemeOptions] - Additional options to deep merge with MUI theme",
  "methods": [],
  "displayName": "ThemeMuiBase",
  "props": {
    "prefix": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "An arbitrary theme prefix"
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "The content to wrap in the ThemeProvider"
    },
    "getThemeObject": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Function that provides the theme object"
    }
  }
};
var _default = ThemeMuiBase;
exports.default = _default;